import { ColumnDef } from "@tanstack/react-table";
import { BiDotsHorizontalRounded } from "react-icons/bi";

// Helper function for date formatting
const formatDate = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleDateString();
};

// ==================== DOCUMENT TYPES COLUMNS ====================
export const documentTypesColumns: ColumnDef<any>[] = [
	{
		accessorKey: "name",
		header: "Name",
		size: 200,
		minSize: 150,
		maxSize: 350,
	},
	{
		accessorKey: "description",
		header: "Description",
		size: 380,
		minSize: 250,
		maxSize: 600,
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		minSize: 150,
		maxSize: 250,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 200,
		minSize: 150,
		maxSize: 250,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		id: "actions",
		header: "Actions",
		size: 100,
		minSize: 80,
		maxSize: 150,
		cell: ({ row, table }) => {
			const meta = table.options.meta as any;
			return (
				<button
					onClick={(e) => {
						e.stopPropagation();
						if (meta?.onActionClick) {
							meta.onActionClick(row.original, e);
						}
					}}
					className="p-2 hover:bg-gray-100 rounded-full transition-colors"
				>
					<BiDotsHorizontalRounded className="text-xl" />
				</button>
			);
		},
	},
];

// Default column visibility
export const documentTypesColumnVisibility = {
	name: true,
	description: true,
	createdAt: true,
	modifiedAt: true,
	actions: true,
};
